import React from 'react'
import { useSelector } from 'react-redux';
import './imageViewer.css'
const ImageView = ({imageData}) => {      
  return (
    <div className="image-preview-list">
    {imageData?.map((img, index) => (
      <div key={index} className="image-card">
        <p className="image-filename">{img.fileName}</p>
        <img
          src={`data:image/png;base64,${img.base64}`}
          alt={img.fileName}
          className="image-preview"
        />
      </div>
    ))}
  </div>
  )
}

export default ImageView
